import React, { useState } from "react";
import { FieldDropSide } from "../Forms";
import { Field, Formik } from "formik";
import SearchableList from "../SearchableList/SearchableList";
import { Button, Form } from "react-bootstrap";
import {
  getBasicPlanDetails,
  getCompaniesList,
  getEmployerSourceListForNonPayPeriod,
  getNonPayPeriodReportData,
  getPlanList,
} from "../../services";
import { useRequest } from "../../abstracts";
import {
  clearFieldValues,
  formFields,
  manageReportsFormNames,
  required,
  usDateFormat,
} from "../../utils";
// import { get } from "lodash";
// import DateRangeSelector from "../DateRangeSelector/DateRangeSelector";
import { DatePicker } from "../";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUndo } from "@fortawesome/pro-light-svg-icons";
import FiltHeaderText from "../NonPayPeriodReportComponent/FiltHeaderText";
import { isEmpty } from "lodash";
import { useEffect } from "react";

const SearchFilterNonPayPeriod = ({
  filterValues,
  setGridData,
  setFilterValues,
  setToastData,
  sourceList1,
  planList1,
  planYear1,
}) => {
  const [planList, setPlanList] = useState([]);
  const fields = formFields[manageReportsFormNames.NON_PAY_PERIOD_REPORT];
  const [sourceList, setSourceList] = useState([]);
  let [planYear, setPlanYear] = useState([]);
  useEffect(() => {
    if (planYear1 != null) {
      setPlanYear(planYear1);
    }
  }, [planYear1]);

  let planEffectiveYear = new Date(planYear?.effectiveDate)?.getFullYear();
  const getPayDateOptions = [];
  const currentYear = new Date().getFullYear();
  const yearsToShow = Math.min(currentYear - planEffectiveYear + 1, 5);

  for (let i = 0; i < yearsToShow; i++) {
    getPayDateOptions.push({
      label: currentYear - i,
      value: i + 1,
    });
  }

  const { response: data } = useRequest({
    method: getCompaniesList,
    payload: 1,
    defaultResponse: [],
  });

  const initialValues = {
    [fields.fromDate]: null,
    [fields.toDate]: null,
  };
  return (
    <Formik
      initialValues={{
        [fields.companyId]: filterValues.companyId ?? "",
        [fields.companyName]: filterValues.companyName ?? "",
        [fields.planId]: filterValues.planId ?? "",
        [fields.planName]: filterValues.planName ?? "",
        [fields.allocationSource]: filterValues.allocationSource ?? "",
        [fields.allocationSourceId]: filterValues.allocationSourceId ?? "",
        [fields.planYear]: filterValues.planYear ?? "",
        [fields.fromDate]: null,
        [fields.toDate]: null,
      }}
      enableReinitialize
      validateOnChange={false}
      validateOnBlur={false}
      onSubmit={(values, { setSubmitting }) => {
        setFilterValues(values);
        if (
          values.companyName &&
          values.planName &&
          values.allocationSource &&
          values.planYear
        ) {
          getNonPayPeriodReportData({
            companyId: values.companyId,
            planId: values.planId,
            allocationSourceId: values.allocationSourceId,
            planYear: values.planYear,
            generationFromDate: values.fromDate ?? null,
            generationToDate: values.toDate ?? null,
            from: 0,
            offset: 20,
            order: 1,
          }).then((res) => {
            setGridData(res.nonPayPeriodReportData);
          });
        }
        setSubmitting(false);
      }}
    >
      {({
        handleChange,
        setFieldValue,
        handleSubmit,
        // setFieldError,
        setValues,
        values,
        // errors,
        setErrors,
        touched,
        ...rest
      }) => {
        const handleCompanyChange = (cId, value) => {
          setValues({
            ...clearFieldValues({
              values: values,
              fieldsToClear: [
                fields.planName,
                fields.allocationSource,
                fields.planYear,
              ],
            }),
          });
          setFieldValue(fields.companyName, value);
          setFieldValue(fields.companyId, cId);
          setPlanYear([]);
          setSourceList([]);
          getPlanList(cId).then((response) => {
            if (response.length == 1 && response[0]?.status != 0) {
              setFieldValue(fields.planName, response[0].name);
              setFieldValue(fields.planId, response[0].id);
              getBasicPlanDetails(response[0].id).then((response) => {
                setPlanYear(response.plan);
              });
              getEmployerSourceListForNonPayPeriod(response[0].id).then(
                (response) => {
                  setSourceList(
                    response.map((val) => ({
                      label: val.name,
                      value: val.id,
                    }))
                  );
                }
              );
            }
            setPlanList(response.filter((_) => _?.status != 0) ?? []);
          });
        };

        const onPlanChange = (selectedValue, value) => {
          setValues({
            ...clearFieldValues({
              values: values,
              fieldsToClear: [fields.allocationSource, fields.planYear],
            }),
          });
          setFieldValue(fields.planName, selectedValue);
          setFieldValue(fields.planId, value);
          getBasicPlanDetails(value).then((response) => {
            setPlanYear(response.plan);
          });
          getEmployerSourceListForNonPayPeriod(value).then((response) => {
            setSourceList(
              response.map((val) => ({
                label: val.name,
                value: val.id,
              }))
            );
          });
        };

        const generateOption = (Array.isArray(planList1) && planList1.length > 0
          ? planList1
          : planList
        ).map((plan) => ({
          ...plan,
          label: plan.name,
          label1: plan.rkPlanNumber,
          value: plan.id,
        }));

        const handleSourceSelect = (selectedlabel, value) => {
          setFieldValue(fields.allocationSource, selectedlabel);
          setFieldValue(fields.allocationSourceId, value);
        };

        const onDaySelected = (fieldName, value) => {
          setFieldValue(fieldName, value);
        };

        return (
          <>
            <Form>
              <div className="d-flex mt-1 align-items-center">
                <div className="mr-3 header-nPayPeriod ">
                  <FiltHeaderText text={"Company name"} />
                  <Field
                    size="smd"
                    isRequired
                    placeholder="Select"
                    name={fields.companyName}
                    value={values[fields.companyName]}
                    direction="right"
                    validate={required}
                    popupContent={
                      <SearchableList
                        label="Select Company"
                        options={
                          data &&
                          data.map((company) => ({
                            label: company.name,
                            value: company?.id,
                          }))
                        }
                        onSelect={handleCompanyChange}
                        selectedValue={values[fields.companyName]}
                        name={fields.companyName}
                      />
                    }
                    component={FieldDropSide}
                  />
                </div>

                <div className="mr-3 header-nPayPeriod ">
                  <FiltHeaderText text={"Plan name & ID"} />
                  <Field
                    noLabelTransform
                    size="sm"
                    isRequired
                    name={fields.planName}
                    value={values[fields.planName]}
                    placeholder="Select"
                    direction="right"
                    validate={required}
                    popupContent={
                      <SearchableList
                        label="Search Plan name or ID"
                        page="managePayroll"
                        options={planList && generateOption}
                        onSelect={(val, label) => onPlanChange(label, val)}
                        selectedValue={values[fields.planName]}
                      />
                    }
                    component={FieldDropSide}
                  />
                </div>
                <div className="mr-3 header-nPayPeriod ">
                  <FiltHeaderText text={"Allocation source"} />
                  <Field
                    noLabelTransform
                    size="sm"
                    isRequired
                    validate={required}
                    name={fields.allocationSource}
                    value={values[fields.allocationSource]}
                    placeholder="Select"
                    direction="right"
                    popupContent={
                      <SearchableList
                        label="Search source"
                        options={
                          Array.isArray(sourceList1) && sourceList1.length > 0
                            ? sourceList1
                            : sourceList
                        }
                        onSelect={(val, label) =>
                          handleSourceSelect(label, val)
                        }
                        selectedValue={values[fields.allocationSource]}
                      />
                    }
                    component={FieldDropSide}
                  />
                </div>
                <div className="mr-3 header-nPayPeriod">
                  <FiltHeaderText text={"Plan year"} />
                  <Field
                    noLabelTransform
                    size="sm"
                    isRequired
                    validate={required}
                    name={fields.planYear}
                    value={values[fields.planYear]}
                    placeholder="Select"
                    direction="right"
                    popupContent={
                      <SearchableList
                        label="Select plan year"
                        options={getPayDateOptions}
                        onSelect={(val, label) => {
                          setFieldValue(fields.planYear, label);
                        }}
                        selectedValue={values[fields.planYear]}
                      />
                    }
                    component={FieldDropSide}
                  />
                </div>
                <div className="mr-3 optional-header-nPayPeriod justify-content-between">
                  <FiltHeaderText
                    text={"Generation date range"}
                    isRequired={false}
                  />
                  <div className="d-flex">
                    <div style={{ marginRight: "15px" }}>
                      <Field
                        size="sm"
                        name={fields.fromDate}
                        // label = "Generation date range"
                        value={usDateFormat(values.fromDate)}
                        isDatePicker
                        placeholder="From date"
                        direction="bottom"
                        onClear={() => onDaySelected(fields.fromDate, "")}
                        popupContent={
                          <DatePicker
                            onDayClick={(value) =>
                              onDaySelected(fields.fromDate, value)
                            }
                            value={usDateFormat(values.fromDate)}
                          />
                        }
                        component={FieldDropSide}
                      />
                    </div>

                    <Field
                      size="sm"
                      // label=""
                      text=""
                      name={fields.toDate}
                      isRequired
                      placeholder="To date"
                      value={usDateFormat(values.toDate)}
                      direction="bottom"
                      isDatePicker
                      onClear={() => onDaySelected(fields.toDate, "")}
                      onDefaultClearDisplay={values.toDate}
                      popupContent={
                        <DatePicker
                          onDayClick={(value) =>
                            onDaySelected(fields.toDate, value)
                          }
                          value={usDateFormat(values.toDate)}
                        />
                      }
                      component={FieldDropSide}
                      validate={(value) => {
                        return [undefined, null, ""].includes(value) ? (
                          ""
                        ) : value <= values.fromDate ? (
                          <div style={{ width: "150px" }}>
                            {"Should be ahead of 'From Date'"}
                          </div>
                        ) : //? "PL559 : Pay Date From must be greater than Pay Date to"
                        undefined;
                      }}
                    />
                  </div>
                </div>
                {/* </div> */}
                <div>
                  <Button
                    variant="link"
                    className="reset-nPayPeriod"
                    onClick={(e) => {
                      setValues(initialValues);
                      setFieldValue(fields.fromDate, initialValues.fromDate);
                      setFieldValue(fields.toDate, initialValues.toDate);
                      setPlanList([]);
                      setSourceList([]);
                      setPlanYear([]);
                      setGridData([]);
                      setErrors({});
                      setToastData(false);
                      const mandatoryFields = [
                        fields.companyName,
                        fields.planName,
                        fields.allocationSource,
                        fields.planYear,
                      ];
                      // mandatoryFields.forEach((field) =>
                      //   setFieldError(field, "")
                      // );
                    }}
                  >
                    <FontAwesomeIcon className="mr-2" icon={faUndo} />
                    Reset
                  </Button>
                </div>
                <div>
                  <Button variant="secondary" size="sm" onClick={handleSubmit}>
                    Search
                  </Button>
                </div>
              </div>
            </Form>
          </>
        );
      }}
    </Formik>
  );
};

export default SearchFilterNonPayPeriod;
